import { Fragment, h } from 'preact'; /** @jsx h */
import { useEffect, useRef, useState } from 'preact/hooks';
import { Form, MultipleStepHandler } from './FormWrappers';
import { ContactStep, PersonInfoStep, SumStep } from './GeneralFormContent';
import GiftForm from './GiftForm';
import { getPerson, registrerMember } from './apiFunctions';
import { Events, formName } from './events';
import { findInSession, getInitFormData, setInSession, updateFormData } from './variables';

const nextStepText = 'Gå videre';
const submitButtonText = 'Bli støttemedlem';

const { paymentInfo, paymentError, user } = window.NLA;
const isLoggedIn = user != null;
const initData = getInitFormData(paymentInfo);
let events;

const SupportUsForm = ({
    id,
    renderCb,
    options,
    kamp,
    titleStep1,
    level,
    isStudent = false,
    blockCode,
    infoTxtStep1
}) => {
    const [formData, setFormData] = useState({ ...initData, kamp });
    const [monVal, setMonVal] = useState(true);
    const [ignoredLogin, setIgnoredLogin] = useState({ phone: '', ignored: false });
    const [mobileLookupSuccess, setMobileLookupSuccess] = useState(false);
    const [showWelcomeStep, setShowWelcomeStep] = useState(false);
    const [showErrorStep, setShowErrorStep] = useState(false);

    const formUrl = `${window.location.pathname}#${id}`;

    const formRef = useRef(null);
    const errorHeadingRef = useRef(null);
    const welcomeHeadingRef = useRef(null);

    const flatOptions = options.flat();

    useEffect(() => {
        renderCb(id);
        const newData = { ...formData, optionList: flatOptions };
        if (flatOptions) {
            newData.optionList = [
                ...flatOptions,
                { value: ' ', label: 'eller skriv valgfritt beløp', isDefault: false }
            ];
            const selectedSum = selectedOption(options);
            if (selectedSum) newData.giftValue = selectedSum;
        }
        const sessionSum = findInSession('sufgiftvalue');
        if (sessionSum) newData.giftValue = sessionSum;

        if (flatOptions) setFormData(newData);

        events = new Events(formName.supportus, kamp, blockCode);

        events.startEvent();
    }, []);

    useEffect(() => {
        if (welcomeHeadingRef && welcomeHeadingRef.current) {
            welcomeHeadingRef.current.focus();
        } else if (errorHeadingRef && errorHeadingRef.current) {
            errorHeadingRef.current.focus();
        }
    }, [showWelcomeStep, showErrorStep]);

    const changeFormData = (inval, e) => {
        if (e.target.value || e.target.value === '') {
            const newObj = { ...formData };
            newObj[inval] = e.target.value;
            setFormData(newObj);
            events.changeEvent(inval);
        }
    };
    const selectedOption = arr => {
        let sel;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].isDefault) {
                sel = arr[i].value;
                break;
            }
        }
        return sel;
    };
    const changeData = response => {
        updateFormData(response, formData, setFormData);
    };
    const checkPhoneNumber = () => {
        return new Promise((resolve, reject) => {
            const noSpacePhoneNumber = formData.phoneNumber.replace(/\s/g, '');

            const validPhone = /^\+?\d{8,12}$/.test(noSpacePhoneNumber);

            if (validPhone && ignoredLogin.phone !== formData.phoneNumber) {
                getPerson({ mobilnr: noSpacePhoneNumber, mr: 'N' })
                    .then(response => {
                        if (response && Object.keys(response).length > 0) {
                            changeData(response);
                            setMobileLookupSuccess(true);
                            events.phoneLookUpEvent('success');
                        }
                        setMobileLookupSuccess(false);
                        events.phoneLookUpEvent('failed');
                        resolve(true);
                    })
                    .catch(e => {
                        setMobileLookupSuccess(false);
                        events.phoneLookUpEvent('failed');
                        reject(e);
                    });
            } else {
                setIgnoredLogin({ ...ignoredLogin, phone: formData.phoneNumber });
                resolve(validPhone || formData.phoneNumber === '');
            }
        });
    };

    const registrerMemberCall = () => {
        return new Promise((resolve, reject) => {
            // send formData with fetch
            registrerMember({ ...formData, student: isStudent ? 'J' : 'N' })
                .then(response => {
                    // then show welcome step with pay buttons
                    setShowWelcomeStep(true);
                    resolve(response);
                })
                .catch(e => {
                    setShowErrorStep(true);
                    reject(e);
                });
        });
    };

    const changeSelect = event => {
        if (event.target && event.target.value) {
            setFormData({ ...formData, giftValue: event.target.value });
            setMonVal(true);
            setInSession('sufgiftvalue', event.target.value);
        }
    };

    const HeaderTag = `h${level}`;

    if (showErrorStep) {
        return (
            <Fragment>
                <HeaderTag id={id} tabIndex="-1" ref={errorHeadingRef}>
                    Ops! Noe gikk galt.
                </HeaderTag>
                <p>
                    Vi fikk ikke registrert deg som nytt støttemedlem. Kontakt oss på telefon eller
                    prøv igjen senere
                </p>
            </Fragment>
        );
    }

    if (isLoggedIn) {
        return (
            <GiftForm
                id={id}
                renderCb={renderCb}
                kamp={kamp === 'dflt' ? 'sg_dflt' : kamp}
                level={level}
                blockCode={blockCode}
            />
        );
    }

    if (showWelcomeStep) {
        return (
            <Fragment>
                <HeaderTag id={id} tabIndex="-1" ref={welcomeHeadingRef}>
                    Velkommen
                </HeaderTag>
                <p className="step-info-text">
                    Tusen takk for at du har blitt støttemedlem. Klikk på Avtalegiro eller Vipps for
                    å velge betalingsmåte. Hvis du ikke velger en av de vil vi sende deg en giro i
                    posten.
                </p>
                <ul className="supportPaymentList">
                    <li>
                        <a className="submitBtn" href="/medl/giver_betaling.php">
                            Signer AvtaleGiro her
                        </a>
                    </li>
                    <li>
                        <a href="/medl/giver_betaling_vipps.php" className="vipps-link">
                            <img
                                src="/wp-content/themes/n16e-theme/images/payment/betal-med-vipps.svg"
                                alt="Betal med vipps"
                                className="vipps-logo-img"
                            />
                        </a>
                    </li>
                </ul>
                <p className="step-info-text">
                    Du har nå tatt et viktig og riktig valg som vil hjelpe fremtidens akutt syke og
                    skadde.
                </p>
            </Fragment>
        );
    }

    const pages = [
        {
            name: 'initInfo',
            content: (
                <SumStep
                    titleStep1={titleStep1 || 'Støtt vårt arbeid nå'}
                    infoText={infoTxtStep1 || 'Bidra med en fast sum hver måned.'}
                    paymentError={paymentError}
                    formUrl={formUrl}
                    kamp={kamp}
                    lbl="Kr/mnd"
                    optionList={formData.optionList}
                    value={monVal ? formData.giftValue : ''}
                    setVal={changeSelect}
                    onFocus={() => setMonVal(false)}
                    id={id}
                    level={level}
                    blockCode={blockCode}
                    isStudent={isStudent}
                />
            ),
            btnTxt: nextStepText
        },
        {
            name: 'contactInfo',
            content: <ContactStep {...formData} changeFormData={changeFormData} level={level} />,
            btnTxt: nextStepText,
            nextFunction: checkPhoneNumber
        },
        {
            name: 'personInfo',
            content: (
                <PersonInfoStep
                    {...formData}
                    changeFormData={changeFormData}
                    setFormData={setFormData}
                    isDataFromLookup={mobileLookupSuccess}
                    level={level}
                />
            ),
            btnTxt: submitButtonText,
            nextFunction: registrerMemberCall
        },
        {
            name: 'welcomeInfo',
            content: <p>Hvordan vil du betale?</p>,
            btnTxt: submitButtonText
        }
    ];

    return (
        <Form id={id} tabIndex="-1" method="post" action="/medl/giver_create_2.php" ref={formRef}>
            <MultipleStepHandler
                pageArr={pages}
                formRef={formRef}
                updateStepEvent={step => events.updateStepEvent(step)}
            />
        </Form>
    );
};

export default SupportUsForm;
